export default __webpack_public_path__ + "static/media/ceo-slide2.c15d9bb0.jpg";